export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNCAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjYxNjYgMjMuNTczNkwxMS45NDc5IDIyLjk3NjVMMTEuMjgxNiAyMy41NzYzTDEgMzIuODMxM0wxIDFMMjMgMUwyMyAzMi44NDM2TDEyLjYxNjYgMjMuNTczNloiIHN0cm9rZT0iI0ZGNTU3NCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notsaved.svg
// module id = 226
// module chunks = 0 1 2 5 6